@if (display$ | async; as display) {
  <div>
    <section [class.open]="display === 'open'"
      (click)="close()">
      <div (click)="$event.stopPropagation()"
        [ngClass]="showFileUploadArea ? 'custom-modal-float-dialog-container' : 'mini-custom-modal-float-dialog-container'">
        @if (showFileUploadArea) {
          <h2 style="padding: 24px 24px 0 24px ;margin-top: 20px;" class="mobile-padding"  >Uploads</h2>
        }
        <div class="main-wrapper">
          @if (showFileUploadArea) {
            <div style="padding:24px;" class="common-upload-table flex fl-col width-100per">
              <!-- COMMON HEADER -->
              <div class="common-upload-table__header flex width-100per" style="padding-left: 12px;">
                <p style="min-width: 40%;" class="width-40per flex fl-al-center set-mobile-witdh">FILE</p>
                <p class="width-20per flex fl-al-center mobile-witdh-size" style="padding-left: 28px;" >SIZE</p>
                <p  style="min-width: 25%;" class="width-25per flex fl-al-center hide-on-mobilile">DESTINATION</p>
                <p class="width-15per flex fl-al-center mobile-witdh-status" style="justify-content: flex-end;padding-right: 12px;" >STATUS</p>
              </div>
              <!-- COMMON BODY -->
              @for (node of fileListDataTree; track node; let i = $index) {
                <div class="width-100per" >
        <div style="display: flex;flex-direction: column;width: 100%;    margin-top: 6px;
        border-bottom: 1px solid #D3DCE8;
        padding: 6px 0px;
        margin-bottom: 6px;">
                    <div style="display: flex;flex-direction: row;" >
                      <div
                        style="min-width: 40%;"
                        [ngClass]="checkIsFile(node.data.isDirectory,node.data,node.name) ? 'mltop12' : 'mltop12'"
                        class="width-40per  set-mobile-witdh flex-align-center flex custom-button mostly-customized-scrollbar">
                        @if (checkIsFile(node.data.isDirectory,node.data,node.name)) {
                          <img src="assets/images/folder-icon.svg" />
                        } @else {
                          <img src="assets/images/file-icon.svg" />
                        }
                        <p class="ml-10 text-truncate" >
                          {{ node.name }}
                        </p>
                      </div>
                      <div class="width-20per flex-align-center mobile-witdh-size">
                        <p class="title">
                          {{ getSizeInUnits(node.data,node.name) }}
                        </p>
                      </div>
                      <div style="min-width: 25%;" class="width-25per flex-align-center hide-on-mobilile" matTooltip="{{ node.data.fullPath }}">
                        <p class="sub-title text-truncate">
                          <!-- {{ node.data.fullPath | truncateStrPipe: 15 }} -->
                          {{ node.data?.fullPath |  bulkFileUploadedUrl : node }}
                        </p>
                      </div>
                      <div class="width-15per flex-align-center mobile-witdh-status"
                        [ngClass]="checkIsFile(node.data.isDirectory,node.data,node.name) ? '' : 'mlzero-positive'"
                        style="text-align: -webkit-right;padding-right: 24px;" >
                        @if (checkFileuploadIsdone(node.data?.fullPath) == 'running') {
                          <div  class="spinner-finished ml-10">
                            <!-- <mat-spinner [diameter]="20"></mat-spinner> -->
                          </div>
                        }
                        @if (checkFileuploadIsdone(node.data?.fullPath) == 'success') {
                          <div   class="spinner-finished ml-10">
                            <img src="assets/images/completed-check.svg" />
                          </div>
                        }
                        @if (checkFileuploadIsdone(node.data?.fullPath) == 'fail') {
                          <div   class="spinner-finished ml-10">
                            X
                          </div>
                        }
                      </div>
                    </div>
                    <div class="show-on-mobile" >
                      <p class="sub-title text-truncate location-div" >
                        <!-- {{ node.data.fullPath | truncateStrPipe: 15 }} -->
                        {{ node.data?.fullPath |  bulkFileUploadedUrl : node }}
                      </p>
                    </div>
                  </div>        </div>
                }
                @if (showLader) {
                  <div style="width:100%" >
                    <div  class="ph-item firstelement" style="border: 0px;" >
                      <div  class="ph-col-12" style="padding: 0px !important;">
                        <div class="ph-item" style="padding: 0px !important;border: 0px !important;margin: 0px;height: 14px;">
                          <div>
                            <div class="ph-row">
                              <div class="ph-col-12 big"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div  class="ph-col-12" style="padding: 0px !important;">
                        <div class="ph-item" style="padding: 0px !important;border: 0px !important;margin: 0px;height: 14px;">
                          <div>
                            <div class="ph-row">
                              <div class="ph-col-12 big"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div  class="ph-col-12" style="padding: 0px !important;">
                        <div class="ph-item" style="padding: 0px !important;border: 0px !important;margin: 0px;height: 14px;">
                          <div>
                            <div class="ph-row">
                              <div class="ph-col-12 big"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            <div class="action-footer">
              <div class="flex-center">
                <button mat-raised-button  (click)="RevieSHowFile()" >
                  <i class="material-icons">
                    {{showFileUploadArea? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
                  </i>
                </button>
                @if (itemCounter) {
                  <p
                    class="ml-10 text-white " style="display: flex;">
                    <span style="font-weight: 400;">
                      {{fileCompltedStack.length }}
                    </span>
                    <span style="font-weight: 400;" >
                      /{{ itemCounter }}
                    </span>
                    @if (!showFileUploadArea) {
                      <span style="margin-left: 12px;font-size: 24px;" class="material-icons add-item-icon show-on-mobile">upload</span>
                    }
                    <span  [ngClass]="showFileUploadArea ? '' : 'hide-on-mobilile'">
                      &nbsp;  {{itemCounter == 1 ? 'File': 'Files' }} Uploaded
                    </span>
                  </p>
                }
              </div>
              <div>
                @if ((!(itemCounter-fileCompltedStack.length) && itemCounter)) {
                  <button (click)="DoneCliek()" mat-raised-button>Done</button>
                }
                @if ((itemCounter-fileCompltedStack.length) && screenWidth>650) {
                  <button
                    [ngClass]="showFileUploadArea ? '' : 'hide-on-mobilile'"
                    mat-raised-button>
                    {{itemCounter-fileCompltedStack.length}} {{itemCounter-fileCompltedStack.length == 1 ? 'Item':'Items'}} Remaining
                  </button>
                }
                @if ((itemCounter-fileCompltedStack.length) && screenWidth<650) {
                  <button
                    [ngClass]="showFileUploadArea ? '' : 'hide-on-mobilile'"
                    mat-raised-button>
                    Uploading
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  }